import type { Role } from "@/types/api/types.ts";

export const ROLE_USER: Role = "ROLE_USER";
export const ROLE_ADMIN: Role = "ROLE_ADMIN";
export const ROLE_SUPER_ADMIN: Role = "ROLE_SUPER_ADMIN";

export const ROLE_i18n_KEY = Object.freeze({
  ROLE_USER: "auth.roles.user",
  ROLE_ADMIN: "auth.roles.admin",
  ROLE_SUPER_ADMIN: "auth.roles.superAdmin",
});
